import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { URI } from "core/classes/uri.class";

class LoadMoreItems extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.$loadMoreButton = this.element.find("[data-load-more-button]");
    this.$loadMoreButtonWrapper = this.element.find(
      "[data-load-more-button-wrapper]"
    );
    this.itemsToLoad = +this.$loadMoreButton.attr("data-items-to-load");
    this.loadMoreContext = this.element.find("[data-load-more-context]");
    this.addAriaLabels();
    this.setOptions(options);
    this.setUpEvents();
  }

  addAriaLabels() {
    this.loadMoreContext.attr("aria-live", "assertive");
    this.findHiddenItems().attr("aria-hidden", "true");
  }

  setUpEvents() {
    var self = this;
    this.$loadMoreButton.on("click", function() {
      self.load();
    });
  }

  findHiddenItems() {
    return this.element.find("[data-load-more-context]").find(".hiddenItem");
  }

  load() {
    var self = this,
      hiddenItems = this.findHiddenItems();
    hiddenItems
      .filter(function(index, $item) {
        return index < self.itemsToLoad;
      })
      .removeClass("hiddenItem")
      .attr("aria-hidden", "false")
      .first()
      .attr("tabindex", "0")
      .focus()
      .on("blur", function() {
        $(this)
          .removeAttr("tabindex")
          .off("blur");
      });

    var hiddenItemsCheck = this.findHiddenItems();

    if (!hiddenItemsCheck.length > 0) {
      this.hideLoadMoreButton();
    }
  }

  hideLoadMoreButton() {
    this.$loadMoreButtonWrapper.addClass("hide");
  }
}

export { LoadMoreItems };



// WEBPACK FOOTER //
// ./Javascript/core/classes/loadmoreitems/loadmoreitems.class.js